import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

import auth from './auth'
import notification from './notification'
import setting from './setting'

Vue.use(Vuex)

const authPersist = new VuexPersist({
  storage: window.localStorage,
  modules: ['auth', 'setting']
})

export default new Vuex.Store({
  modules: {
    auth,
    notification,
    setting
  },
  state: {
    /* NavBar */
    isNavBarVisible: true,

    /* FooterBar */
    isFooterBarVisible: true,

    /* Aside */
    isAsideCollapsed: true
  },
  mutations: {
    /* A fit-them-all commit */
    basic (state, payload) {
      state[payload.key] = payload.value
    },

    /* Aside Mobile */
    asideMobileStateToggle (state, payload = null) {
      const htmlClassName = 'has-aside-mobile-expanded'

      let isShow

      if (payload !== null) {
        isShow = payload
      }

      if (isShow) {
        document.documentElement.classList.add(htmlClassName)
      } else {
        document.documentElement.classList.remove(htmlClassName)
      }
    },

    asideCollapseToggle (state, payload = null) {
      const htmlClassName = 'has-aside-collapsed'

      let isCollapsed

      if (payload !== null) {
        isCollapsed = payload
      } else {
        isCollapsed = !state.isAsideCollapsed
      }

      state.isAsideCollapsed = isCollapsed

      if (isCollapsed) {
        document.documentElement.classList.add(htmlClassName)
      } else {
        document.documentElement.classList.remove(htmlClassName)
      }
    }
  },
  plugins: [authPersist.plugin]
})
